



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// ADDPLANPOST
// ADDPLANPOST
const DELETEPLAN= createAsyncThunk(
  "deletePlan/deletePlan",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const deletePlanSlice = createSlice({
  name: "deletePlanSlice",
  initialState: {
    deletePlan: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfdeletePlan: (state) => {
        state.deletePlan.loading = false
        state.deletePlan.error = false
        state.deletePlan.data = []
        state.deletePlan.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(DELETEPLAN.fulfilled, (state, action) => {
      state.deletePlan = {
        ...state.deletePlan,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETEPLAN.pending, (state, action) => {
      state.deletePlan = {
        ...state.deletePlan,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETEPLAN.rejected, (state, action) => {
      state.deletePlan = {
        ...state.deletePlan,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const deletePlanAction = {
    DELETEPLAN,
};

export { deletePlanAction };
export default deletePlanSlice.reducer;
export const {setInitialStateOfdeletePlan} = deletePlanSlice.actions